module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"h1":"Forgot password?","h2":"Enter an email or phone number for password recovery"},"ru":{"h1":"Забыли пароль?","h2":"Введите номер телефона для получения кода безопасности","enter-number":"Вернуться к вводу номера"}}')
  delete Component.options._Ctor
}
